module.exports = __webpack_public_path__ + "static/img/share.895b438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/13/share.jpg
// module id = p/gd
// module chunks = 27